import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadReportsEpic } from './_epics/loadReports.epic';
import { loadReportDataEpic } from './_epics/loadReportData.epic';
import { loadAccountSymbolsEpic } from './_epics/loadAccountSymbols.epic';
import { loadFilterOptionsEpic } from './_epics/loadFilterOptions.epic';
import { loadFormSymbolsEpic } from './_epics/loadFormSymbols.epic';
import { createReportEpic } from './_epics/createReport.epic';
import { stopReportEpic } from './_epics/stopReport.epic';
import { retryReportEpic } from './_epics/retryReport.epic';
import { pollReportsEpic } from './_epics/pollReports.epic';

export const markoutEpic = safeCombineEpics(
  loadReportsEpic,
  loadReportDataEpic,
  loadAccountSymbolsEpic,
  loadFilterOptionsEpic,
  loadFormSymbolsEpic,
  createReportEpic,
  stopReportEpic,
  retryReportEpic,
  pollReportsEpic,
);
